<script setup>
import { navLinksAdmin } from "@/constants";
import { ChevronLeft, ChevronRight } from "lucide-vue-next";

const props = defineProps({
  collapsed: Boolean,
  setCollapsed: Function,
  isDeviceDesktop: Boolean,
});

const toggleCollased = () => {
  props.setCollapsed();
};
</script>
<template>
  <aside
    class="fixed top-0 left-0 bg-white h-screen z-50 shadow-md border-r border-gray-200 transition-all duration-300 flex flex-col"
    :class="
      props.isDeviceDesktop
        ? props.collapsed
          ? 'w-16'
          : 'w-68'
        : props.collapsed
        ? '-transition-x-full w-68'
        : 'transition-x-0 w-68'
    "
  >
    <div class="flex items-center justify-between p-4 border-b border-gray-200">
      <div v-show="!props.collapsed" class="flex items-center gap-3">
        <img src="" alt="" />
        <div class="flex flex-col">
          <span class="font-bold text-sm"> NDUKA </span>
          <span> Área Administrativa </span>
        </div>
      </div>
      <button
        @click="toggleCollased"
        v-if="props.isDeviceDesktop"
        class="p-1.5 btn-ghost rounded-lg hover:bg-gray-100 transition-colors"
      >
        <component
          :is="props.collapsed ? ChevronRight : ChevronLeft"
          class="text-gray-600 w-5 h-5"
        />
      </button>
    </div>

    <!-- Menu -->
    <div
      class="flex-1 flex flex-col overflow-y-auto overflow-x-hidden p-3 [scrollbar-width:_thin]"
    >
      <template
        v-for="section in navLinksAdmin"
        :key="section.title || section.links[0].label"
      >
        <p class="text-gray-500 uppercase text-xs font-bold px-2 mb-1">
          {{ section.title }}
        </p>

        <!-- Links -->
        <RouterLink
          v-for="link in section.links"
          :key="link.href"
          :to="link.href"
          class="flex items-center gap-3 p-2 rounded text-gray-500 hover:bg-gray-100 transition-colors"
          :class="collapsed && 'md:w-[45px]'"
        >
          <component :is="link.icon" class="w-5 h-5 flex-shrink-0" />
          <p v-if="!props.collapsed" class="whitespace-nowrap text-[14px]">
            {{ link.label }}
          </p>
        </RouterLink>
      </template>
    </div>
  </aside>
</template>